import { Breakpoints } from 'types/breakpoints';

export const mobileStyles = `@media (max-width: ${Breakpoints.MOBILE}px)`; // 0-1023

export const tabletStyles = `@media (min-width: ${
    Breakpoints.MOBILE + 1
}px) and (max-width: ${Breakpoints.TABLET}px)`; // 1024 - 1439

export const desktopStyles = `@media (min-width: ${Breakpoints.DESKTOP}px)`; // 1440 +
